
<template>
  <div class="lending-container">
    <InfoContainer
      class="lending_container"
      style="margin-top: 20px"
      :infoTitle="lendingInfo['infoTitle']"
      :contentConfig="lendingInfo['infoContent']"
    >
      <template slot="basicInfo">
        <avue-crud
          :option="lendingConfig"
          :data="lendingTableData"
          :page.sync="page"
          @on-load="queryLendingList"
          @selection-change="selectionChange"
        >
          <template slot="menuLeft">
            <el-button size="small" type="primary" @click="handleAdd()">
              新增放款
            </el-button>
            <el-button size="small" type="primary" plain @click="handleEdit()">
              编辑
            </el-button>
            <el-button size="small" type="danger" plain @click="handleDelete()">
              删除
            </el-button>
            <el-button size="small" type="primary" @click="handleCancel()" v-if="permission.factoring_writeoff">
              核销
            </el-button>
          </template>

          <template slot-scope="scope" slot="menu">
            <div class="detail-button" @click="handleDetail(scope.row.id)">
              <i class="el-icon-video-play"></i>详情
            </div>
          </template>

          <template slot="investStr" slot-scope="{ row }">
            <div class="project-name">
              第{{ investBatch }}批/第{{ row.paymentBatch }}笔
            </div>
          </template>
        </avue-crud>
      </template>
    </InfoContainer>

    <!-- 放款信息 -->
    <template v-for="(item, i) in lendingTableData">
      <InfoContainer
        :key="i"
        style="margin-top: 20px"
        :infoTitle="`第${investBatch}批/第${item.paymentBatch}笔 放款`"
        :contentConfig="lendingDetailInfoConfig['infoContent']"
      >
        <template #basicInfo>
          <CommonDetail :configArray="investInfo" :initValue="item" />
        </template>
        <template #innerDetail>
          <el-table :data="item.innerList" border style="width: 100%">
            <el-table-column
              type="index"
              align="center"
              label="序号"
              width="50"
            >
            </el-table-column>
            <el-table-column
              align="center"
              property="moneyType"
              label="款项类型"
            >
              <template slot-scope="scope">
                <div
                  class="money-type"
                  v-if="scope.row.dictMainOutlayType == 2"
                >
                  卖方保证金
                </div>
                <div class="money-type" v-else>
                  {{ scope.row.outlayTypeStr }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="outlayAmount"
              label="应收金额（元）"
            >
              <template slot-scope="scope">
                {{ getMoney(Number(scope.row.outlayAmount)) }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="innerPayment"
              label="当前可内扣金额（元）"
            >
              <template slot-scope="scope">
                {{ getMoney(Number(scope.row.innerPayment)) }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="innerMoney"
              label="本次内扣金额（元）"
            >
              <template slot-scope="scope">
                {{ getMoney(Number(scope.row.innerMoney)) }}
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template #rentTable>
          <el-table :data="item.rentplanList" border style="width: 100%">
            <el-table-column align="center" property="issue" label="期数">
            </el-table-column>
            <el-table-column align="center" property="rentDay" label="还款日">
              <template slot-scope="scope">
                {{
                  `${scope.row.rentDay.toString().slice(0, 4)}年
                   ${scope.row.rentDay.toString().slice(4, 6)}月
                   ${scope.row.rentDay.toString().slice(6, 8)}日`
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="expectedRent"
              label="每期保理首付款及保理首付款使用费合计额"
            >
              <template slot-scope="scope">
                {{ getMoney(Number(scope.row.expectedRent)) }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="principal"
              label="每期保理首付款"
            >
              <template slot-scope="scope">
                {{ getMoney(Number(scope.row.principal)) }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="interest"
              label="每期保理首付款使用费"
            >
              <template slot-scope="scope">
                {{ getMoney(Number(scope.row.interest)) }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="residualPrincipal"
              label="剩余保理首付款"
            >
              <template slot-scope="scope">
                {{ getMoney(Number(scope.row.residualPrincipal)) }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="cashFlow"
              label="现金流量"
            >
              <template slot-scope="scope">
                {{ getMoney(Number(scope.row.cashFlow)) }}
              </template>
            </el-table-column>
          </el-table>
        </template>
      </InfoContainer>
    </template>

    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="addLendingVisble"
      :modal-append-to-body="false"
      width="70%"
      class="addLending_dialog"
    >
      <template v-if="showType == 'add' || showType == 'edit'">
        <!-- 新增放款 -->
        <avue-form
          ref="lendingInfo"
          v-model="lendingForm"
          :option="lendingFormConfig"
        >
          <template #investBatchStr>
            <div class="slot-content">第{{ investBatch }}批</div>
          </template>

          <template #bankInfo>
            <div class="slot-content">
              {{ lendingForm.custBankBl.bankAccountName?lendingForm.custBankBl.bankAccountName:'' }}
              {{ lendingForm.custBankBl.bankOpenName?lendingForm.custBankBl.bankOpenName: '' }}
              {{ lendingForm.custBankBl.bankNo?lendingForm.custBankBl.bankNo: '' }}
            </div>
          </template>

          <template #investAllMoney>
            <div class="slot-content green-word">
              {{
                lendingForm.investAllMoney
                  ? `${getMoney(Number(lendingForm.investAllMoney))}元`
                  : "无"
              }}
            </div>
          </template>

          <template #investAlreadyMoney>
            <div class="slot-content green-word">
              {{
                lendingForm.investAlreadyMoney
                  ? `${getMoney(Number(lendingForm.investAlreadyMoney))}元`
                  : "无"
              }}
            </div>
          </template>

          <template #lastMoney>
            <div class="slot-content green-word">
              {{
                `${getMoney(
                  Number(lendingForm.investAllMoney) -
                    Number(lendingForm.investAlreadyMoney)
                )}元`
              }}
            </div>
          </template>

          <template #rentDate>
            <div class="slot-content green-word">
              {{ lendingForm.rentDate }}
            </div>
          </template>

          <template #presentCostSum>
            <div class="slot-content green-word">
              {{ getMoney(lendingForm.presentCostSum) }}元
            </div>
          </template>

          <template #actuallPayment>
            <div class="slot-content green-word">
              {{ getMoney(lendingForm.actuallPayment) }}元
            </div>
          </template>

          <template #innerMoney>
            <el-table :data="lendingForm.innerList" border style="width: 100%">
              <el-table-column
                type="index"
                align="center"
                label="序号"
                width="50"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="moneyType"
                label="款项类型"
              >
                <template slot-scope="scope">
                  <div
                    class="money-type"
                    v-if="scope.row.dictMainOutlayType == 2"
                  >
                    卖方保证金
                  </div>
                  <div class="money-type" v-else>
                    {{ scope.row.outlayTypeStr }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                property="outlayAmountStr"
                label="应收金额（元）"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="innerPaymentStr"
                label="当前可内扣金额（元）"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="presentCost"
                label="本次内扣金额（元）"
                width="250"
              >
                <template slot-scope="scope">
                  <el-input
                    @change="changeCost"
                    type="number"
                    placeholder="请输入内容"
                    v-model="scope.row.presentCost"
                  >
                    <template slot="append">元</template>
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
          </template>

          <template #depositMoney>
            <el-table
              ref="multipleTable"
              :data="marginList"
              border
              @selection-change="handleSelectionChange"
              style="width: 100%">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>              
              <!-- <el-table-column
                type="index"
                align="center"
                label="序号"
                width="50"
              >
              </el-table-column> -->
              <el-table-column
                align="center"
                property="moneyType"
                label="款项类型"
              >
                <template>
                  <div class="money-type">
                    卖方保证金
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                property="receivableAmountStr"
                label="应收金额（元）"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="receivedAmountStr"
                label="已收金额（元）"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="deductedAmountStr"
                label="已抵扣金额（元）"
                width="150"
              >
              </el-table-column>
              <el-table-column
                align="center"
                property="surplusAmountStr"
                label="保证金余额（元）"
                width="150"
              >
              </el-table-column>
            </el-table>
          </template>
        </avue-form>

        <div class="submit-con">
          <el-button type="primary" size="mini" @click="validFormData()"
            >保存</el-button
          >
          <el-button
            type="primary"
            size="mini"
            plain
            @click="addLendingVisble = false"
            >取消</el-button
          >
        </div>
      </template>

      <template v-if="showType == 'detail'">
        <!-- 编辑放款 -->
        <div class="detail-one">
          <div class="detail-top">
            <div class="detail-title">相关信息</div>
          </div>
          <div class="detail-content">
            <CommonDetail :configArray="detailConfig" :initValue="detailData" />
          </div>
        </div>

        <div class="detail-one">
          <div class="detail-top">
            <div class="detail-title">
              本次核销信息
              <span class="title-tips"
                >（{{
                  detailData.writeOff == 0
                    ? "未核销"
                    : `核销人员：${detailData.writeoffUserName}，核销时间:${detailData.writeoffTime}`
                }}）</span
              >
            </div>
          </div>
          <div class="detail-content">
            <CommonDetail
              :configArray="detailConfigTwo"
              :initValue="detailData"
            />

            <div class="detail-content stone-con">
              <template v-for="(item, index) in detailData.paymentDetailList">
                <CommonDetail
                  :key="index"
                  class="stone-detail-one"
                  :configArray="collectionConfig"
                  :initValue="item"
                />
              </template>
            </div>
          </div>
        </div>
      </template>

      <template v-if="showType == 'writeOff'">
        <!-- 核销 -->
        <div class="detail-one">
          <div class="detail-top">
            <div class="detail-title">相关信息</div>
          </div>
          <div class="detail-content">
            <CommonDetail :configArray="detailConfig" :initValue="detailData" />
          </div>
        </div>

        <div class="detail-one">
          <div class="detail-top">
            <div class="detail-title">请填写本次核销信息</div>
          </div>
          <div class="detail-content">
            <avue-form
              ref="lendingInfo"
              v-model="detailData"
              :option="writeOffFormConfig"
            >
              <template #investTitle>
                <div class="slot-content">
                  {{ detailData.projectName }}/{{ detailData.investBatch }}
                </div>
              </template>
              <template #moneyTypeStr>
                <div class="slot-content">{{ detailData.moneyTypeStr }}</div>
              </template>
              <template #shouldPay>
                <div class="slot-content">
                  <div class="content-line">
                    {{ detailData.investShouldMoneyStr }}
                    <span
                      class="show-detail"
                      @click="showDetails = showDetails ? false : true"
                      >{{ showDetails ? "[收起]" : "[本笔放款详情]" }}</span
                    >
                  </div>
                  <div class="detail-block" v-if="showDetails">
                    <div class="detail-inner">
                      <div class="info-one">
                        <div class="info-title green-point">本笔放款金额：</div>
                        <div class="info-content">
                          {{ detailData.investMoney }}
                        </div>
                      </div>
                      <!-- 资金投放 -->
                      <div class="info-one" v-if="detailData.moneyType == 0">
                        <div class="info-title green-point">内扣明细：</div>
                        <div class="info-content"></div>
                      </div>
                      <template v-if="detailData.moneyType == 0">
                        <!-- <template  > -->
                          <div class="info-one" :key="index" v-for="(item, index) in detailData.innerList">
                            <div class="info-title">
                              {{ item.outlayTypeStr }}：
                            </div>
                            <div class="info-content">
                              {{ getMoney(Number(item.outlayAmount)) }}元
                            </div>
                          </div>
                        <!-- </template> -->
                      </template>
                      <div class="info-one" v-if="detailData.moneyType == 0">
                        <div class="info-title">合计：</div>
                        <div class="info-content">
                          {{ detailData.totalCost }}
                        </div>
                      </div>

                      <!-- 保证金归还 -->
                      <div class="info-one" v-if="detailData.moneyType == 1">
                        <div class="info-title green-point">保证金明细：</div>
                        <div class="info-content"></div>
                      </div>
                      <template v-if="detailData.moneyType == 1">
                        <!-- <template  > -->
                          <div class="info-one" :key="index" v-for="(item, index) in marginList">
                            <div class="info-title">
                              保证金：
                            </div>
                            <div class="info-content">
                              {{ getMoney(Number(item.refundedAmount)) }}元
                            </div>
                          </div>
                        <!-- </template> -->
                      </template>

                      <div class="info-one" v-if="detailData.moneyType == 1">
                        <div class="info-title">合计：</div>
                        <div class="info-content">
                          {{ detailData.investMoney }}
                        </div>
                      </div>
                      <div class="info-one">
                        <div class="info-title green-point">
                          本笔应实付金额：
                        </div>
                        <div class="info-content">
                          {{ detailData.investShouldMoneyStr }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #planPayDate>
                <div class="slot-content">{{ detailData.planPayDate }}</div>
              </template>
              <template #bankInfo>
                <div class="slot-content">{{ detailData.accountName }}</div>
              </template>
            </avue-form>

            <div class="detail-content stone-con">
              <template v-for="(item, index) in paymentList">
                <div class="stone-one" :key="index">
                  <div class="form-con">
                    <avue-form
                      ref="paymentInfo"
                      v-model="paymentList[index]"
                      :option="paymentListConfig"
                    >
                      <template #payBankId>
                        <CommonSelect
                          bindLabel="bankOpenName"
                          bindKey="id"
                          bindValue="bankOpenName"
                          methods="get"
                          dataMethod="params"
                          :initParam="initParam"
                          dataUrl="bl/custbankbl/page"
                          @handleChange="
                            (data) => {
                              setBankInfo(data, index);
                            }
                          "
                        />
                      </template>
                    </avue-form>
                  </div>
                  <!-- <el-divider direction="vertical" v-if="paymentList.length > 1"></el-divider> -->
                  <div class="delete-con" v-if="paymentList.length > 1">
                    <i
                      class="el-icon-delete-solid"
                      @click="deletePayment(item, index)"
                    ></i>
                  </div>
                </div>
              </template>

              <div class="add-btn">
                <el-button size="small" icon="el-icon-plus" @click="addPayment"
                  >添加支付</el-button
                >
              </div>
            </div>

            <div class="submit-con">
              <el-button type="primary" size="mini" @click="validWriteOffForm()"
                >核销</el-button
              >
              <el-button
                type="primary"
                size="mini"
                plain
                @click="addLendingVisble = false"
                >取消</el-button
              >
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  getLendingList,
  addLendingDetail,
  addLending,
  lendingDetail,
  deleteLending,
  cancelLending,
  queryBankList,
  queryMarginList
} from "@/api/factoring/factoring";
import CommonDetail from "@/components/commonDetail/commonDetail";
import CommonSelect from "@/components/commonSelect/commonSelect";
import InfoContainer from "@/components/infoContainer/infoContainer";
import { mapGetters } from "vuex";
import { floatAdd } from "@/util/util";
export default {
  name: "lendingForm",
  data() {
    return {
      dialogTitle: "",
      lendingInfo: {
        infoTitle: "放款信息",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
      lendingDetailInfoConfig: {
        infoTitle: "放款信息",
        infoContent: [
          {
            title: "本批次放款信息",
            prop: "basicInfo",
          },
          {
            title: "内扣明细",
            prop: "innerDetail",
          },
          {
            title: "还款计划表",
            tips: "(此处“还款日”以“计划放款日期”为参考；实际还款计划表，请在“投后—还款计划”中查看)",
            prop: "rentTable",
          },
        ],
      },
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 100,
      },
      showType: "add",
      addLendingVisble: false,
      selectionList: [],
      investArray: [],
      lendingTableData: [],
      lendingConfig: {
        menuType: "button",
        addBtn: false,
        menuWidth: 120,
        menuAlign: "center",
        card: false,
        menu: true,
        delBtn: false,
        editBtn: false,
        align: "center",
        columnBtn: false,
        searchBtn: false,
        selection: true,
        selectionWidth: 45,
        index: true,
        indexLabel: "序号",
        refreshBtn: false,
        column: [
          {
            label: "放款次号",
            prop: "investStr",
            slot: true,
          },
          {
            label: "本笔实付金额",
            prop: "investShouldMoney",
            formatter: (row, value, label, column) => {
              return `${this.getMoney(value)}元`;
            },
            width: 150,
          },
          {
            label: "款项类型",
            prop: "moneyTypeStr",
          },
          {
            label: "计划放款日期",
            prop: "planPayDate",
          },
          {
            label: "放款状态",
            prop: "isWriteoff",
            formatter: (row, value, label, column) => {
              return value == 0 ? "未核销" : "已核销";
            },
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 150,
          },
        ],
      },
      lendingForm: {},
      lendingFormConfig: {
        labelWidth: 180,
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "放款批次",
            prop: "investBatchStr",
            formslot: true,
            span: 14,
            placeholder: "等待生成项目名称",
          },
          {
            label: "收款方银行信息",
            prop: "bankInfo",
            formslot: true,
            span: 14,
          },
          {
            label: "本批投放款金额",
            prop: "investAllMoney",
            formslot: true,
            span: 14,
            disabled: false,
          },
          {
            label: "本批次已放款金额",
            prop: "investAlreadyMoney",
            formslot: true,
            span: 14,
            disabled: false,
          },
          {
            label: "本批次剩余可放金额",
            prop: "lastMoney",
            formslot: true,
          },
          {
            label: "款项类型",
            prop: "moneyType",
            type: "radio",
            span: 14,
            dicData: [
              {
                label: "资金投放",
                value: 0,
              },
              {
                label: "保证金退还",
                value: 1,
              },
            ],
            change: (data) => {
              this.changeMoneyType(data)
            },
            rules: [
              {
                required: true,
                message: "请选择款项类型",
                trigger: "change",
              },
            ],
          },
          {
            label: "本笔放款金额",
            prop: "investMoney",
            span: 14,
            append: "元",
            disabled: false,
            change: (data) => {
              if (data.value != "" && data.value > 0) {
                this.lendingForm.investMoney = data.value;
                this.changeCost();
              }
            },
            rules: [
              {
                required: true,
                message: "请输入本笔放款金额",
                trigger: "change",
              },
            ],
          },
          {
            label: "计划放款时间",
            type: "date",
            prop: "planPayDate",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            span: 14,
            rules: [
              {
                required: true,
                message: "请选择计划放款时间",
                trigger: "change",
              },
            ],
          },
          {
            label: "还款日",
            prop: "rentDate",
            formslot: true,
            display: true,
            span: 14,
          },
          {
            label: "内扣明细",
            prop: "innerMoney",
            formslot: true,
            display: true,
            span: 24,
          },
          {
            label: "保证金明细",
            prop: "depositMoney",
            formslot: true,
            display: false,
            span: 24,
          },          
          {
            label: "内扣合计金额",
            prop: "presentCostSum",
            formslot: true,
            display: true,
            span: 24,
          },
          {
            label: "本笔应实付金额",
            prop: "actuallPayment",
            formslot: true,
            display: true,
            span: 24,
          },
          {
            label: "支付方式",
            prop: "payType",
            type: "radio",
            span: 14,
            dicData: [
              {
                label: "电汇",
                value: 0,
              },
              {
                label: "银行承兑汇票",
                value: 1,
              },
              {
                label: "电商",
                value: 2,
              },
              {
                label: "其它",
                value: 3,
              },
            ],
          },
          {
            label: "补充说明",
            prop: "otherCondition",
            span: 14,
            type: "textarea",
          },
        ],
      },
      showDetails: false,
      writeOffFormConfig: {
        labelWidth: 150,
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "款项标题",
            prop: "investTitle",
            formslot: true,
            span: 14,
          },
          {
            label: "款项类型",
            prop: "moneyTypeStr",
            formslot: true,
            span: 14,
            placeholder: "等待生成项目名称",
          },
          {
            label: "应付金额",
            prop: "shouldPay",
            formslot: true,
            span: 14,
          },
          {
            label: "计划付款日期",
            prop: "planPayDate",
            formslot: true,
            span: 14,
          },
          {
            label: "客户收款账号",
            prop: "bankInfo",
            formslot: true,
            span: 14,
          },
        ],
      },
      // 应付款详情
      detailData: {},
      detailConfig: [
        {
          label: "项目名称",
          prop: "projectName",
          span: "12",
        },
        {
          label: "业务类型",
          prop: "projectType",
          span: "12",
        },
        {
          label: "收款方",
          prop: "sellerCustName",
          span: "12",
        },
        {
          label: "保理商",
          prop: "accountingEntity",
          span: "12",
        },
        {
          label: "保理合同",
          prop: "contractName",
          span: "12",
        },
        {
          label: "对应当款批次",
          prop: "investBatch",
          span: "12",
        },
      ],
      detailConfigTwo: [
        {
          label: "款项标题",
          prop: "moneyTitle",
          span: "12",
        },
        {
          label: "款项类型",
          prop: "moneyTypeStr",
          span: "12",
        },
        {
          label: "应付金额",
          prop: "investShouldMoneyStr",
          span: "12",
        },
        {
          label: "计划付款日期",
          prop: "planPayDate",
          span: "12",
        },
        {
          label: "客户收款账号",
          prop: "accountName",
          span: "12",
        },
      ],

      investInfo: [
        {
          label: "本笔放款金额",
          span: "12",
          prop: "investAllMoney",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        {
          label: "计划放款日期",
          span: "12",
          prop: "rentDate",
        },
        {
          label: "内扣合计金额",
          span: "12",
          prop: "innerCost",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        {
          label: "实际应付金额",
          span: "12",
          prop: "investMoney",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        {
          label: "支付方式",
          span: "12",
          prop: "payType",
          formatter: (label, value) => {
            return value == 0
              ? "电汇"
              : value == 1
              ? "银行承兑汇票"
              : value == 2
              ? "商票"
              : "其它";
          },
        },
        {
          label: "补充说明",
          span: "24",
          prop: "remarks",
        },
      ],

      collectionConfig: [
        {
          label: "付款账号",
          prop: "paymentAccountStr",
          span: "14",
        },
        {
          label: "付款金额",
          prop: "payMoney",
          span: "14",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        {
          label: "付款日期",
          prop: "payDate",
          span: "14",
        },
      ],

      // 付款信息
      bankList: [],
      paymentListConfig: {
        labelWidth: 240,
        backgroundColor: "#f7f9fe",
        align: "center",
        submitBtn: false,
        emptyBtn: false,
        menuBtn: false,
        menu: false,
        column: [
          {
            label: "付款帐号",
            prop: "payBankId",
            formslot: true,
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择付款帐号",
              },
            ],
          },
          {
            label: "付款金额",
            type: "input",
            prop: "payMoney",
            span: 24,
            append: "元",
            rules: [
              {
                required: true,
                message: "请输付款金额",
              },
            ],
          },
          {
            label: "付款日期",
            type: "date",
            prop: "payDate",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择付款日期",
              },
            ],
          },
        ],
      },
      initParam: { isBusiness: 1 },
      paymentList: [
        {
          payBankId: "",
          payMoney: "",
          payDate: "",
          paymentId: "",
        },
      ],

      // 保证金数据
      marginList: [],
      multipleSelection: []
    };
  },
  props: {
    investBatch: {
      type: String,
      default: "0",
    },
    investId: {
      type: String,
      required: true,
    },
    investData: {
      type: String,
      default: () => {
        return {};
      },
    },
  },
  components: {
    CommonDetail,
    CommonSelect,
    InfoContainer,
  },
  computed: {
    ...mapGetters(["userInfo", "permission"]),
  },  
  async mounted() {
    // 查询放款信息列表
    // this.queryLendingList()
    // 查询新增前详情
    this.queryAddLandingDetail();
  },
  methods: {
    handleSelectionChange(val) {
      let self = this
      let newArray = []
      let marginTotal = 0
      this.lendingForm.depositAmounts = []
      // 处理保证金数据
      val.map((item, index) => {
        if(Number(item.surplusAmount) != 0) {
          // 计算保证金总额
          marginTotal =floatAdd(marginTotal,Number(item.surplusAmount)) 
          newArray.push(item)
          // 设置上传数据
          self.lendingForm.depositAmounts.push({
            depositId: item.id,
            refundedAmount: item.surplusAmount
          })
        }else {
          self.$refs.multipleTable.toggleRowSelection(item)
          self.$message.warning(`第${item.index}条保证金数据余额为0无法选择`)
        }
      })
      this.multipleSelection = newArray
      this.lendingForm.investMoney = marginTotal
    },

    async changeMoneyType(data) {
      let self = this
      let innerIncludesArray = ["innerMoney", "rentDate", "presentCostSum", "actuallPayment"]
      let depositIncludesArray = ["depositMoney"]
      this.lendingFormConfig.column.map((item) => {
          if(innerIncludesArray.includes(item.prop)){
            item.display = data.value == 0?true:false
          }
          if(depositIncludesArray.includes(item.prop)){
            item.display = data.value == 0?false:true
          }
          if(item.prop == "investMoney") item.disabled = data.value == 0?false:true
      })

      if(data.value == 1) {
        let newArray = []
        this.lendingForm.depositAmounts = []
        // 查询保证金数据
        let res = await queryMarginList({investId: this.investId})
        if(res.data.code == 200) {
          this.marginList = res.data.data
          this.marginList.map((item, index) => {
            item.index = index + 1
            item.receivableAmountStr = `${self.getMoney(Number(item.receivableAmount))}元`
            item.receivedAmountStr = `${self.getMoney(Number(item.receivedAmount))}元`
            item.deductedAmountStr = `${self.getMoney(Number(item.deductedAmount))}元`
            item.surplusAmountStr = `${self.getMoney(Number(item.surplusAmount))}元`
            if(item.refundedAmount != '' && item.refundedAmount != 0) {
              newArray.push(item)
            }
          })

          this.multipleSelection = newArray
          setTimeout(() => {
            if(newArray.length> 0) {
              newArray.map(item => {
                self.$refs.multipleTable.toggleRowSelection(item)
              })
            }
          },300)
        }
      }
    },
    setBankInfo(data, index) {
      this.paymentList[index].payBankId = data.id;
    },
    addPayment() {
      let obj = {
        payBankId: "",
        payMoney: "",
        payDate: "",
        paymentId: "",
      };
      this.paymentList.push(obj);
    },
    deletePayment(data, index) {
      let self = this;
      this.$confirm("确定删除该条支付信息?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let newArray = [];
        newArray = newArray.concat(
          JSON.parse(JSON.stringify(self.paymentList))
        );
        newArray.splice(index, 1);
        self.paymentList = newArray;
      });
    },
    async queryAddLandingDetail() {
      let res = await addLendingDetail({ investId: this.investId });
      this.lendingForm = res.data.data;
      // 处理内扣合计金额 本笔应实付金额
      this.lendingForm.presentCostSum = 0;
      this.lendingForm.actuallPayment = 0;
      this.lendingForm.innerList.map((item) => {
        item.outlayAmountStr = `${this.getMoney(Number(item.outlayAmount))}元`;
        item.innerPaymentStr = `${this.getMoney(Number(item.innerPayment))}元`;
      });
    },

    changeCost() {
      this.lendingForm.presentCostSum = 0;
      this.lendingForm.innerList.map((item) => {
        if (item.presentCost) {
          this.lendingForm.presentCostSum=floatAdd(this.lendingForm.presentCostSum,Number(item.presentCost));
        }
      });
      // 计算笨比应实付金额
      if (this.lendingForm.investMoney && this.lendingForm.investMoney != "") {
        this.lendingForm.actuallPayment =
          this.lendingForm.investMoney - this.lendingForm.presentCostSum;
      } else {
        this.$message({
          type: "warning",
          message: "请先输入本笔放款金额",
        });
      }
      this.$forceUpdate();
    },

    async queryLendingList() {
      let res = await getLendingList({ investId: this.investId });
      if (res.data.code == 200) {
        this.lendingTableData = res.data.data.records;
        this.lendingTableData.map((item) => {
          if (item.innerList.length > 0) {
            item.innerCost = 0; 
            item.innerList.map((i) => {
              item.innerCost = floatAdd(item.innerCost,Number(i.innerMoney));
            });
          }
        });
      }
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    async handleDetail(id) {
      this.dialogTitle = "详情";
      this.showType = "detail";
      // 查询详情
      let res = await lendingDetail({ id: id });
      let detailData = res.data.data;
      this.addLendingVisble = true;
      this.dealDetailData(detailData);
    },

    dealDetailData(detailData) {
      let totalCost = 0;

      detailData.innerList.map((i) => {
        totalCost =floatAdd(totalCost,Number(i.innerMoney)) ;
      });
      if (detailData.paymentDetailList.length > 0) {
        detailData.paymentDetailList.map((item) => {
          if(JSON.stringify(item.custBankBl) != '{}'){
            item.paymentAccountStr = `${item.custBankBl.bankAccountName} ${item.custBankBl.bankOpenName} ${item.custBankBl.bankNo}`;
          }else {
            item.paymentAccountStr = '暂无银行信息'
          }
        });
      }
      this.detailData = {
        projectName: this.investData.blReportStandard.name,
        projectType: this.investData.blReportStandard.projectTypeStr,
        sellerCustName: this.investData.contractManage.sellerCustName,
        sellerCustId: this.investData.contractManage.sellerCustId,
        accountingEntity: detailData.formAccountingEntityStr,
        // contractName: this.investData.contractManage.name?this.investData.contractManage.name: '',
        investBatch: `第${this.investBatch}批`,
        planPayDate: detailData.planPayDate,
        investMoney: `${this.getMoney(Number(detailData.investMoney))}元`,
        moneyType: detailData.moneyType,
        moneyTypeStr: detailData.moneyType == 1 ? "保证金退还" : "资金投放",
        accountName: `${detailData.custBankBl.bankAccountName} ${detailData.custBankBl.bankOpenName} ${detailData.custBankBl.bankNo}`,
        moneyTitle: `${this.investData.blReportStandard.name}/第${this.investBatch}批`,
        writeOff: detailData.isWriteoff,
        innerList: detailData.innerList,
        investAllMoney: `${this.getMoney(Number(detailData.investAllMoney))}元`,
        totalCost: `${this.getMoney(totalCost)}元`,
        investShouldMoneyStr: `${this.getMoney(
          detailData.investShouldMoney
        )}元`,
        investShouldMoney: detailData.investShouldMoney,
        paymentDetailList: detailData.paymentDetailList,
        writeoffUserName: detailData.writeoffUserName,
        writeoffTime: detailData.writeoffTime,
        contractName: detailData.contractName,
      };
    },

    async handleAdd() {
      if(this.investData.managerUser == this.userInfo.user_id ) {
        this.lendingFormConfig.column[5].disabled = false
        this.lendingForm = {}
        this.queryAddLandingDetail();
        this.dialogTitle = "新增放款";
        this.showType = "add";
        this.addLendingVisble = true;
      } else {
        this.$message.warning('您暂无权限新增该笔投放放款')
      }

      // this.lendingForm = {}
    },

    async handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        if(this.investData.managerUser == this.userInfo.user_id) {
            this.dialogTitle = "编辑放款";
            this.lendingFormConfig.column[5].disabled = true
            let data = this.selectionList[0];          
          if(data.isWriteoff == 0){
            if(data.moneyType == 1) {
              this.changeMoneyType({value: 1})
            }
            let res = await lendingDetail({ id: data.id });
            if (res.data.code == 200) {
              let resData = res.data.data;
              this.lendingForm.id = resData.id;
              this.lendingForm.moneyType = resData.moneyType;
              this.lendingForm.investMoney = resData.investMoney;
              this.lendingForm.payType = resData.payType;
              this.lendingForm.otherCondition = resData.remarks;
              this.lendingForm.actuallPayment = resData.investShouldMoney;
              this.lendingForm.planPayDate = resData.planPayDate;
              this.lendingForm.innerList = resData.innerList;
              this.lendingForm.innerList.map((item) => {
                item.outlayAmountStr = `${this.getMoney(
                  Number(item.outlayAmount)
                )}元`;
                item.innerPaymentStr = `${this.getMoney(
                  Number(item.innerPayment)
                )}元`;
                item.presentCost = Number(item.innerMoney).toFixed(2);
              });
              this.showType = "edit";
              this.addLendingVisble = true;
            }
          }else {
            this.$message.warning('该条数据已核销')
          }
        }else {
          this.$message.warning('您暂无权限编辑该条放款数据')
        }
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    handleDelete() {
      let self = this;
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行删除");
      } else if (this.selectionList.length == 1) {
        if(this.investData.managerUser == this.userInfo.user_id) {
          this.$confirm("确定删除选择的数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              self.deleteData();
            })
            .catch(() => {
              self.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        }else {
          this.$message.error("您暂无权限删除该条放款")
        }
      } else {
        this.$message.error("请选择一条数据进行删除");
      }
    },

    async deleteData() {
      let data = this.selectionList[0];
      let res = await deleteLending({ ids: data.id });
      if (res.data.code == 200) {
        this.queryLendingList();
        this.$message({
          type: "success",
          message: "删除成功",
        });
      }
    },

    async handleCancel() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行核销");
      } else if (this.selectionList.length == 1) {
        if(this.permission.factoring_writeoff) {
          if (this.selectionList[0].isWriteoff == 0) {
            this.dialogTitle = "核销";
            this.showType = "writeOff";
            let res = await lendingDetail({ id: this.selectionList[0].id });
            let marginRes = await queryMarginList({investId: this.investId})
            if(marginRes.data.code == 200) {
              this.marginList = marginRes.data.data
            }
            this.addLendingVisble = true;
            this.dealDetailData(res.data.data);
          } else {
            this.$message.error("该条数据已核销");
          }
        }else {
          this.$message.warning('您暂无权限进行放款核销')
        }

      } else {
        this.$message.error("请选择一条数据进行核销");
      }
    },
    async validWriteOffForm() {
      // 校验付款信息
      let valid = true;
      let self = this;
      this.paymentList.map((item, index) => {
        if (item.payBankId == "" || item.payMoney == "" || item.payDate == "") {
          valid = false;
          self.$message({
            type: "warning",
            message: `请先补全第${index + 1}条付款信息`,
          });
        } else {
          item.paymentId = self.selectionList[0].id;
        }
      });
      if (valid) {
        // 核销
        let params = {
          id: self.selectionList[0].id,
          custId: this.detailData.sellerCustId,
          paymentDetails: this.paymentList,
          investId: this.investId,
        };
        let res = await cancelLending(params);
        if (res.data.code == 200) {
          this.addLendingVisble = false;
          this.queryLendingList();
          this.$message({
            type: "success",
            message: "核销成功",
          });
        }
      }
    },

    validFormData() {
      let self = this;
      let msg = ''
      this.$refs.lendingInfo.validate((valid, done) => {
        done();
        if (valid) {
          // 校验内扣明细
          let formFinish = true;
          if(self.lendingForm.moneyType == 0) {
            self.lendingForm.innerList.map((item) => {
              if (!item.presentCost || item.presentCost == "") {
                formFinish = false;
                msg = "请补全内扣明细本次内扣金额"
              }
            });
          }else {
            // 判断是否有勾选
            if(self.lendingForm.investMoney == 0 || self.lendingForm.investMoney == '') {
              formFinish = false
              msg = "本笔放款金额为0无法发起放款"
            }
          }

          if (formFinish) {
            self.sumbitForm();
          } else {
            self.$message({
              type: "warning",
              message: msg,
            });
          }
        } else {
          self.$message({
            type: "warning",
            message: "请补全表单后提交",
          });
        }
      });
    },

    async sumbitForm() {
      let newArray = [];
      this.lendingForm.innerList.map((item) => {
        newArray.push({
          // paymentId: this.investId,
          outlayId: item.otherOutlayId,
          innerMoney: item.presentCost,
        });
      });
      let params = {
        investId: this.investId,
        collectionBankId: this.lendingForm.collectionBankId,
        custId: this.lendingForm.custBankBl.custId,
        moneyType: this.lendingForm.moneyType,
        investMoney: this.lendingForm.investMoney,
        payType: this.lendingForm.payType,
        remarks: this.lendingForm.otherCondition,
        planPayDate: this.lendingForm.planPayDate,
        investShouldMoney: this.lendingForm.actuallPayment,
      };
      if(this.lendingForm.moneyType == 0) {
        params.paymentOutlays = newArray
      }else {
        params.depositAmounts = this.lendingForm.depositAmounts?this.lendingForm.depositAmounts: []
      }
      if (this.lendingForm.id != -1) params.id = this.lendingForm.id;
      let res = await addLending(params);
      if (res.data.code == 200) {
        this.addLendingVisble = false;
        this.queryLendingList();
        this.$message({
          type: "success",
          message: this.showType == "add" ? "新增成功" : "修改成功",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.lending-container {
  .lending_container {
    /deep/ .detail-one {
      padding-left: 20px !important;
      padding-right: 20px !important;
      padding-bottom: 0px !important;
    }
  }
  .info-container-temp .box-card .detail-one {
    padding: 0 !important;
  }
  /deep/ .el-dialog__header {
    border-radius: 5px 5px 0px 0px;
    // background-color: rgb(245, 245, 245);
    color: #333;
  }
  /deep/ .el-dialog__body {
    padding: 10px 20px 20px !important;
  }
  /deep/ .el-form-item__label {
    font-weight: 700;
    font-style: normal;
    color: #999999;
    text-align: right;
    min-width: 150px;
    padding-right: 12px;
  }
  /deep/ .el-col {
    padding-left: 0 !important;
  }
  /deep/ .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0 !important;
  }
  .detail-button {
    font-size: 12px;
    color: #19be6b;
    cursor: pointer;
    margin-left: 15px;
  }
  .show-detail {
    color: #409eff;
    cursor: pointer;
    margin-left: 10px;
  }
  .detail-block {
    // height: 230px;
    background: inherit;
    background-color: rgba(249, 249, 249, 1);
    border-width: 1px;
    border-style: solid;
    border-color: rgba(233, 233, 233, 1);
    border-radius: 3px;
    .detail-inner {
      width: 100%;
      padding: 20px 30px 20px 50px;
      .info-one {
        display: flex;
        .info-title {
          width: 120px;
          position: relative;
          color: #666666;
          font-size: 12px;
        }
        .green-point::before {
          width: 8px;
          height: 8px;
          border-radius: 4px;
          content: "";
          position: absolute;
          background-color: #51d351;
          top: 13px;
          left: -15px;
        }
        .info-content {
          color: #333;
          font-size: 12px;
        }
      }
    }
  }

  .detail-one {
    padding: 0px 30px !important;
    .detail-top {
      padding: 20px 5px;
      .detail-title {
        color: #666;
        font-weight: 700;
        font-size: 14px;
        line-height: 28px;
        position: relative;
        .title-tips {
          font-weight: 400;
          color: #666666;
          font-size: 13px;
        }
      }
      .detail-title::before {
        content: "";
        width: 5px;
        background-color: #409eff;
        height: 18px;
        position: absolute;
        left: -12px;
        top: 5px;
      }
    }

    .stone-con {
      width: 88%;
      margin: 0 auto;
      .stone-detail-one {
        background-color: #f7f9fe;
        padding: 10px 10px 10px 10px;
        border: 1px solid #e4e4e4;
        border-radius: 4px;
        margin-bottom: 10px;
        .el-collapse-item__wrap {
          background-color: #f7f9fe !important;
          border: none !important;
        }
        .el-collapse {
          border: none !important;
        }
        .el-form-item {
          margin-top: 14px !important;
          margin-bottom: 14px !important;
        }
      }
      .stone-one {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #f7f9fe;
        padding: 30px 10px 10px 10px;
        border: 1px solid #e4e4e4;
        border-radius: 4px;
        margin-bottom: 10px;
        .form-con {
          border-right: 1px dashed #e4e4e4;
        }
        .delete-con {
          width: 300px;
          height: 100%;
          text-align: center;
          i {
            font-size: 30px;
            color: #409eff;
          }
        }
        .el-collapse-item__wrap {
          background-color: #f7f9fe !important;
          border: none !important;
        }
        .el-collapse {
          border: none !important;
        }
        .el-form-item {
          margin-top: 14px !important;
          margin-bottom: 14px !important;
        }
      }
      /deep/.el-collapse-item__wrap {
        background-color: #f7f9fe !important;
        border: none !important;
      }
      /deep/.el-collapse {
        border: none !important;
      }
    }

    .add-btn {
      text-align: right;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
  .submit-con {
    text-align: center;
    margin-bottom: 40px;
    button {
      width: 150px;
    }
  }
}
.addLending_dialog {
  /deep/ .el-dialog {
    height: 600px;
  }
}
</style>